import SpriteSymbol from "../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.store/svg-sprite-loader@4.3.0/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-password-show",
  "use": "icon-password-show-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-password-show\">\n<path d=\"M35.7,125H14.3C6.4,125,0,118.6,0,110.7V89.3C0,81.4,6.4,75,14.3,75h21.3C43.6,75,50,81.4,50,89.3v21.3\n\tC50,118.6,43.6,125,35.7,125z\" />\n<path d=\"M107.1,78.7l21.5,37.2c2.3,4.1-0.6,9.1-5.3,9.1H80.4c-4.7,0-7.6-5.1-5.3-9.1l21.5-37.2C98.9,74.6,104.8,74.6,107.1,78.7z\" />\n<path d=\"M182.3,76.4l12.2,7.1c3.4,2,5.5,5.6,5.5,9.5v14.1c0,3.9-2.1,7.5-5.5,9.5l-12.2,7.1c-3.4,2-7.6,2-10.9,0l-12.2-7.1\n\tc-3.4-2-5.5-5.6-5.5-9.5V92.9c0-3.9,2.1-7.5,5.5-9.5l12.2-7.1C174.7,74.4,178.9,74.4,182.3,76.4z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/password-show.svg
// module id = EDi2
// module chunks = 3